import { render, staticRenderFns } from "./Downloading.vue?vue&type=template&id=2f2c04bf&scoped=true"
import script from "./Downloading.vue?vue&type=script&lang=js"
export * from "./Downloading.vue?vue&type=script&lang=js"
import style0 from "./Downloading.vue?vue&type=style&index=0&id=2f2c04bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2c04bf",
  null
  
)

export default component.exports